<ol class="items-list row w-100 mx-0 mb-2">
  @for (item of items(); track item.title) {
    <li class="col-12 col-md-12 col-xl-12 px-0">
      <a href="javascript:void(0)" class="items-list-item" (click)="clickLink.emit(item)">
        <span class="item-icon {{ item?.icon }}" aria-hidden="true"></span>
        <div class="item-container">
          <div class="item-text">
            <span>{{ item.title }}</span>
            <small class="item-desc">{{ item.subTitle }}</small>
          </div>
        </div>
      </a>
    </li>
  }
</ol>
